<mat-calendar
  [selected]="selectedDate"
  [comparisonStart]="weekStart"
  [comparisonEnd]="weekEnd"
  (selectedChange)="selectedChange($event)"
  [id]="'cal' + calendarNumber"
  #matCalendar
>
</mat-calendar>
